import { useMemo } from 'react'
import { Header, type NavItemInterface } from '../../base/Header'
import { Footer } from '../../base/Footer'
import { paths } from '@/configs/paths'
import { useAppStore } from '@/stores'
import { getFirstDayOfCurrentMonth, getLastDayOfCurrentMonth } from '@/utils/dateTime'

const CustomerAdminLayout = ({ children }) => {
  const user = useAppStore((state) => state.user)

  const navItems: NavItemInterface[] = useMemo(
    () => [
      {
        label: 'Deliveries',
        href: paths.deliveries.path,
        activeMatchers: [paths.deliveries.path, paths.outboundDetail.path, paths.outboundEdit.path]
      },
      {
        label: 'Purchase',
        href: paths.purchaseBuy.getHref(getFirstDayOfCurrentMonth(), getLastDayOfCurrentMonth()),
        activeMatchers: [paths.purchaseBuy.path, paths.purchaseReturn.path]
      },
      {
        label: 'Master',
        subItems: [
          { label: 'User', href: paths.userMaster.path },
          {
            label: 'Product',
            href: paths.customerMasterProducts.getHref(user?.customer_id, true)
          }
        ]
      }
    ],
    [user?.customer_id]
  )

  return (
    <div className='flex flex-col min-h-screen bg-[#F8FAFF]'>
      <Header navItems={navItems} />
      <main className='flex-1 p-5 pt-4 mt-14'>{children}</main>
      <Footer />
    </div>
  )
}

export default CustomerAdminLayout
